import {
  CountryCode,
  isValidPhoneNumber,
  parsePhoneNumber,
} from 'libphonenumber-js/max';
import checkPhoneWtithWhiteSpace from '@/utils/phoneUtils/checkPhoneWtithWhiteSpace';
import checkTWPhoneFormat from '@/utils/phoneUtils/checkTWPhoneFormat';
import { isEmpty } from 'lodash';

// phoenNumber : string
// countryCode : 'TW', 'US', etc.

const phoneValidator = (
  phoneNumber: string,
  countryCode: CountryCode = 'TW',
  required: boolean
) => {
  // if phone is not required return true when phoneNumber is empty or null
  if (isEmpty(String(phoneNumber)) && !required) {
    return true;
  }

  // if phone is not required and phone is not empty or null check phone format
  if (!isEmpty(String(phoneNumber)) && !required) {
    const isValid = isValidPhoneNumber(phoneNumber, countryCode);
    if (!isValid) return false;
  }

  // if phone is required return false when phoneNumber is empty or null
  if (!phoneNumber && required) {
    return false;
  }

  // if areaCode equal zh-tw (+886) 手機開頭 須為09
  if (countryCode === 'TW' && !checkTWPhoneFormat(phoneNumber)) {
    return false;
  }

  // if phone with white space return false
  if (!checkPhoneWtithWhiteSpace(phoneNumber)) {
    return false;
  }

  const isValid = isValidPhoneNumber(phoneNumber, countryCode);
  if (!isValid) {
    return false;
  }

  const parsePhone = parsePhoneNumber(phoneNumber, countryCode);
  const numType = parsePhone.getType();

  return numType === 'MOBILE';
};

export default phoneValidator;
